import React from "react"
import styled from "styled-components"
import Planet from "Galaxy/wrappers/Planet"
import PlanetImage from "Galaxy/wrappers/PlanetImage"
import racion from "galaxies/blue-galaxy/racion.svg"

const Racion = props => (
  <Planet {...props}>
    <PlanetImage src={racion} blocked={props.blocked} />
  </Planet>
)

export default styled(Racion)``
